///? Default IMPORTS
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

///? Service IMPORTS
import { getOrderDetailsThunk } from "../../redux/NewOrderDetails/action";

///? Component & Styling IMPORTS
import UserGreeting from "../../components/UserGreeting/UserGreeting";
import OfflinePage from "../OfflinePage/OfflinePage";
import { PackerWrapper } from "./Packer.styled";
import { AiOutlineScan } from "react-icons/ai";
import { Divider, message } from "antd";
import BarcodeScanner from "../../components/BarcodeScanner/BarcodeScanner";

///? Constants
message.config({
  maxCount: 1,
});

export class Packer extends Component {
  state = {
    showResult: false,
    showScannerScreen: false,
  };

  updateBoxId = (value) => {
    this.setState({ showScannerScreen: false });
  };

  render() {
    return (
      <div className="centerScreen">
        {this.props.isOnline ? (
          <PackerWrapper>
            <UserGreeting />

            {this.state.showResult ? (
              <h1>Result</h1>
            ) : (
              <>
                <button
                  className="bbtn"
                  onClick={() => this.setState({ showScannerScreen: true })}
                  style={{ marginTop: "2em" }}
                >
                  <AiOutlineScan /> Scan the barcode
                </button>

                {this.state.showScannerScreen && (
                  <BarcodeScanner
                    scan={this.state.showScannerScreen ? true : false}
                    camera={this.state.showScannerScreen ? true : false}
                    redirect="packerProcess"
                    history={this.props.history}
                    getBoxId={this.updateBoxId}
                  />
                )}
              </>
            )}
          </PackerWrapper>
        ) : (
          <OfflinePage />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  isOnline: state.statusReducer?.isOnline,
  newOrderDetails: state.newOrderDetailsReducer,
});

export default withRouter(
  connect(mapStateToProps, { getOrderDetailsThunk })(Packer)
);
